export default __webpack_public_path__ + "static/media/Frozen3.8a3490e2.jpg";